import { render, staticRenderFns } from "./PricingForm.vue?vue&type=template&id=20087dd0&scoped=true"
import script from "./PricingForm.vue?vue&type=script&lang=js"
export * from "./PricingForm.vue?vue&type=script&lang=js"
import style0 from "./PricingForm.vue?vue&type=style&index=0&id=20087dd0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20087dd0",
  null
  
)

export default component.exports